import { handleApiRequest } from "../../hooks/callApi";
export const getProjectIssueLog = async (projectId) => {
    const res = await handleApiRequest(`/api/project/issue-logs/${projectId}`, "get");
    return res;
  };


  export const getAllProjectIssueLog = async () => {
    const res = await handleApiRequest(`/api/project/issue-logs`, "get");
    return res;
  };